import React, {Component} from "react";
import { observer } from "mobx-react";
import DatePicker , { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css"
import ko from 'date-fns/locale/ko';
import {fn_getDateVal, fn_setDateVal} from "../../../function/FnBodyEndOrder";
import {getYear, getMonth} from "date-fns";
const _ = require('lodash');

@observer
class StartDatePicker extends Component {

    render() {
        const {rootStore} = this.props;
        const years = _.range(1990, getYear(new Date()) + 1, 1);
        const months = ["1","2","3","4","5","6","7","8","9","10","11","12"];

        // 요일 반환      
        const getDayName = (date) => {
            return date.toLocaleDateString('ko-KR', {weekday: 'long',}).substr(0, 1);
        }
        
        // 날짜 비교시 년 월 일까지만 비교
        const createDate = (date) => {        
            return new Date(new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0));
        }

        registerLocale("ko", ko);

        return (
           <div>
               <button id="startClearDatePicker" className="hide"></button>
               <DatePicker
                   selected={fn_getDateVal(rootStore).start_val}
                   className="date date-record"
                   dateFormat={"yyyy-MM-dd"}
                   onChange={(date) => {
                       rootStore.endOrderStore.searchDateTerm()
                       fn_setDateVal(rootStore, 'start_val', date);
                   }}
   
                    locale="ko"

                    dayClassName={date => getDayName(createDate(date)) === '토' ? "saturday":
                                          getDayName(createDate(date)) === '일' ? "sunday" : undefined
                    }
                    
                    renderCustomHeader={({
                        date,
                        changeYear,
                        changeMonth,
                        decreaseMonth,
                        increaseMonth
                      }) => (
                        <div style={{margin: 10,display: "flex",justifyContent: "center",}}>
                          <button onClick={decreaseMonth} type="button" className="react-datepicker__navigation react-datepicker__navigation--previous" aria-label="Previous Month">
                            <span className="react-datepicker__navigation-icon react-datepicker__navigation-icon--previous">Next Month</span>
                          </button>
                          <div className="react-datepicker__current-month" onChange={({ target: { value } }) => changeYear(value)}>
                            {date.getFullYear()}년
                          </div>
                          <div className="react-datepicker__current-month" onChange={({ target: { value } }) => changeMonth(months.indexOf(value))}>
                            {months[getMonth(date)]}월
                          </div>
                          <button onClick={increaseMonth} type="button" className="react-datepicker__navigation react-datepicker__navigation--next" aria-label="Next Month">
                            <span className="react-datepicker__navigation-icon react-datepicker__navigation-icon--next">Next Month</span>
                          </button>
                        </div>
                      )}
               />
           </div>
        );
    }
}

export default StartDatePicker;